import { Playlist } from 'components/video/playlist/playlist'
export default Playlist
